<style lang="stylus">
    .float-box
        position fixed
        left 169px
        top 82px
        z-index 99
        width 300px
        max-height calc(100% - 82px)
        overflow-y visible
        padding 6px
        background-color white
        border-radius 8px
        box-shadow -4px 0px 22px 0px rgba(0, 0, 0, 0.1)
        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
            border-radius:10px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius:10px;
            background:rgba(0,0,0,0.1);
            -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
        }
        .meun-item
            display flex
            align-items center
            font-size 14px
            color #333
            height 38px
            line-height 38px
            cursor pointer
            border-radius: $box-radius;
            &:hover
                background-color #F0F0F0
            .meun-icon
                width 24px
                margin-left 16px
            .meun-text
                margin 0 10px
            .meun-suffix
                position absolute
                right 16px
                font-size 10px
                color white
                height 16px
                line-height 16px
                padding 0 6px
                background linear-gradient(102.49deg, #8C8C8C 0%, #646464 100%)
                border-radius 12px
        .divider
            height 1px
            background-color #E5E5E5
            margin 8px 16px
        .rec-tip
            font-size 10px
            color #017FFF
            height 16px
            line-height 16px
            padding 0 8px
            background-color rgba(1, 127, 255, .1)
            border-radius 12px
    .miniprogram-wrap1
        position relative
        &:hover
            .miniprogram-icon
                display flex !important
        .miniprogram-icon
            position absolute
            left calc(100% + 1px)
            transform translateY(-50%)
            top 0
            background #FFFFFF
            border-radius 6px
            box-shadow 0px 0px 22px rgba(0, 0, 0, 0.08), 0px 0px 16px rgba(0, 0, 0, 0.06)
            display none
            flex-direction column
            align-items center
            padding 22px 30px 16px 30px
            .miniprogram-arrow
                position absolute
                left 0
                width 28px
                height 28px
                background #000
                margin-left -14px
                left 50%
                bottom -14px
                background #fff
                transform rotate(45deg)
                display none
                border-radius 3px
            .img-box
                padding 10px
                position relative
                width auto
                height auto
                img
                    width 160px
                    height 160px
            .img-text
                background-image linear-gradient(330.91deg, #017FFF 0%, #66CCFF 100%)
                background-clip text
                -webkit-background-clip text
                -webkit-text-fill-color transparent
                color #8627FF
                font-size 12px
                line-height 16px
                margin-top 12px
                padding 0 10px
                text-align center

            .border_corner
                z-index: 10;
                position: absolute;
                width: 10px;
                height: 10px;
                border: 1px solid #E0E0E0;

            .border_corner_left_top
                top: 0;
                left: 0;
                border-right: none;
                border-bottom: none;
                border-top-left-radius: 0px;

            .border_corner_right_top
                top: 0;
                right: 0;
                border-left: none;
                border-bottom: none;
                border-top-right-radius: 0px;

            .border_corner_left_bottom
                bottom: 0;
                left: 0;
                border-right: none;
                border-top: none;
                border-bottom-left-radius: 0px;

            .border_corner_right_bottom
                bottom: 0;
                right: 0;
                border-left: none;
                border-top: none;
                border-bottom-right-radius: 0px;
    .share-shortcut
        right 46px
        top 58px
        left unset
        max-height calc(100vh - 82px)
        user-select none
        list-style-type none
        .miniprogram-wrap1
            .miniprogram-icon
                position absolute
                left unset
                right calc(100% + 1px)
</style>

<template>
    <ul class="float-box">
        <li class="meun-item" @click="openNull()">
            <img class="meun-icon" :src="require('@/home/assets/img/slider/shortcut/icon-empty.svg')" />
            <p class="meun-text">{{ $t("emptyDrawing") }}</p>
        </li>
        <template v-for="(item, index) in recommendList">
            <li class="meun-item" @click="recommendOpen(item)" :key="index">
                <img
                    v-if="graphicMap[item.lv3ID]"
                    class="meun-icon"
                    :src="require(`@/home/assets/img/slider/shortcut/${graphicMap[item.lv3ID]}.svg`)"
                />
                <p class="meun-text">
                    {{ lang == "en" ? item.name : item["name_" + lang] }}
                </p>
                <img v-if="item.lv3ID == 250" :src="require('@/home/assets/img/new.svg')" />
                <div v-if="item.lv3ID == 250" class="meun-suffix">Beta</div>
            </li>
        </template>
        <template v-if="showProductRecommend">
            <li class="divider"></li>
            <li class="meun-item miniprogram-wrap1" v-if="internal" @click.stop>
                <img class="meun-icon" :src="require('@/home/assets/img/slider/shortcut/icon-max.svg')" />
                <p class="meun-text">
                    {{ lang == "zh" ? "亿图图示小程序" : "EdrawMax Mini Program" }}
                </p>
                <div class="miniprogram-icon">
                    <div class="img-box">
                        <img src="@/home/assets/img/miniprogram/miniprogram.jpg" alt="" />
                        <div class="border_corner border_corner_left_bottom" />
                        <div class="border_corner border_corner_right_bottom" />
                        <div class="border_corner border_corner_right_top" />
                        <div class="border_corner border_corner_left_top" />
                    </div>
                    <div class="img-text">
                        {{ lang === "zh" ? "微信扫码打开小程序" : "Scan the QR code on WeChat to open the mini program" }}
                    </div>
                    <div class="miniprogram-arrow" />
                </div>
            </li>
            <li class="meun-item" @click="openLink('master')">
                <img class="meun-icon" :src="require('@/home/assets/img/slider/shortcut/icon-master.svg')" />
                <p class="meun-text">
                    {{ !internal ? "EdrawMind" : lang == "zh" ? "亿图脑图MindMaster" : "MindMaster" }}
                </p>
                <div class="rec-tip">{{ $t("productRec") }}</div>
            </li>
            <li class="meun-item" @click="openLink('project')">
                <img class="meun-icon" :src="require('@/home/assets/img/slider/shortcut/icon-project.svg')" />
                <p class="meun-text">
                    {{ !internal ? "EdrawProj" : lang == "zh" ? "亿图项目管理EdrawProj" : "EdrawProj" }}
                </p>
                <div class="rec-tip">{{ $t("productRec") }}</div>
            </li>
            <li v-if="internal && showProductRecommend" class="meun-item" @click="openLink('pixso')">
                <img class="meun-icon" :src="require('@/home/assets/img/slider/shortcut/icon-pixso.svg')" />
                <p class="meun-text">{{ lang == "zh" ? "协同设计Pixso" : "Pixso" }}</p>
                <div class="rec-tip">{{ $t("productRec") }}</div>
            </li>
        </template>
    </ul>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    // @Component 修饰符注明了此类为一个 Vue 组件
    // 没有声明Component将无法使用vue的生命周期 Prop等特性
    @Component
    export default class ShortcutBox extends Vue {
        @Prop({
            default: "home",
        })
        from: string;
        get recommendList() {
            return this.$store.state.recommendList;
        }
        // lv3ID对应图的名称(海内外对应关系不一样)
        get graphicMap() {
            return this.internal ? this.graphicMapCn : this.graphicMapEn;
        }
        // 表达式 graphicMap = this.internal ? {} : {} 会导致部分现像获取到空值
        graphicMapCn = {
            "9": "block-diagram", // 基本框图
            "4": "flow-chart", // 基本流程图
            "211": "mind-mapping", // 思维导图
            "250": "roadmap", // 路线图
            "37": "org-chart-auto", // 组织架构图（自动）
            "62": "uml", // UML图
            "114": "floorplan", // 平面布置图
            "103": "circuit", // 基本电路图
            "55": "gantt", // 甘特图
            "244": "software-arch", // 软件架构图
            "92": "network", // 基本网络图
            "6": "swimlane", // 泳道图
            "77": "chen-erd", // Chen ERD
            "109": "process-p&id", // 过程P&ID
            "10": "circle-spoke-diagram", // 圆辐示意图
            "238": "concept-map", // 概念图
            "243": "genogram", // 家谱图
        };
        graphicMapEn = {
            "9": "block-diagram", // 基本框图
            "4": "flow-chart", // 基本流程图
            "211": "mind-mapping", // 思维导图
            "237": "roadmap", // 路线图
            "37": "org-chart-auto", // 组织架构图（自动）
            "62": "uml", // UML图
            "114": "floorplan", // 平面布置图
            "103": "circuit", // 基本电路图
            "55": "gantt", // 甘特图
            //   "244": "software-arch", // 软件架构图
            "92": "network", // 基本网络图
            "6": "swimlane", // 泳道图
            "77": "chen-erd", // Chen ERD
            "109": "process-p&id", // 过程P&ID
            "10": "circle-spoke-diagram", // 圆辐示意图
            "230": "concept-map", // 概念图
            "232": "genogram", // 家谱图
        };

        // NewPage页逻辑复用
        openNullFlag = false;
        lv3List = [];
        activeLv3ID = -1;
        activeLv2ID = -1;
        activeMenuID = -1;
        recentSubclass = [];
        recentTemplate = [];
        allTemplate = null;
        recentLoaded = false;
        searchState = false;
        searchSubClassList = [];
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get isAd() {
            return this.$store.state.isAd;
        }
        get typeItemList() {
            return this.searchState ? this.searchSubClassList : this.lv3List;
        }
        openNull() {
            this.sensors.track("clickAddButton", {
                Catalogues: "selectpage",
                diagram_type: "blankdrawing",
            });
            this.openNullFlag = true;
            this.activeLv3ID = -1;
            this.addNewPage();
        }
        recommendOpen(item) {
            this.sensors.track("clickAddButton", {
                Catalogues: "selectpage",
                diagram_type: item.name,
            });
            // this.activeRecommendID = item.id
            this.addSubclass2Recent(item.lv3ID);
            this.lv3List = item.lv2.lv3;
            this.activeLv3ID = item.lv3ID;
            this.addNewPage();
        }
        openLink(type) {
            let url = "";
            switch (type) {
                case "master":
                    if (this.internal) {
                        url = "https://mm.edrawsoft.cn/?channel=max_new";
                    } else if (["en", "kr", "it", "pt"].includes(this.lang)) {
                        url = "https://www.edrawmind.com/?channel=max_new";
                    } else if (this.lang == "jp") {
                        url = "https://edrawsoft.com/jp/edrawmind/?channel=max_new";
                    } else if (this.lang == "tw") {
                        url = "https://www.edrawmind.com/zh-tw/?channel=max_new";
                    } else {
                        url = `https://www.edrawmind.com/${this.lang}/?channel=max_new`;
                    }
                    this.sensors.track("clickAddButton", {
                        Catalogues: "selectpage",
                        diagram_type: "MindMaster",
                    });
                    break;
                case "pixso":
                    url = "https://pixso.cn/?channel=max_new";
                    this.sensors.track("clickAddButton", {
                        Catalogues: "selectpage",
                        diagram_type: "Pixso",
                    });
                    break;
                case "project":
                    let channel = "max_new";
                    if (this.internal) {
                        url = "https://www.edrawsoft.cn/edrawproject/?channel=" + channel;
                    } else if (["it", "fr", "pt", "de", "es"].includes(this.lang)) {
                        url = `https://www.edrawsoft.com/${this.lang}/edraw-project/?channel=${channel}`;
                    } else if (this.lang == "tw") {
                        url = `https://www.edrawsoft.com/zh-tw/edraw-project/?channel=${channel}`;
                    } else {
                        url = `https://www.edrawsoft.com/edraw-project/?channel=${channel}`;
                    }
                    this.sensors.track("clickProj", {
                        click_proj_way: "new",
                    });
                    break;
            }
            window.open(url);
        }
        addNewPage() {
            let ts: any = this;
            let maxAction = this.$store.state.appState;
            let typeTrack = "default";
            if (maxAction) {
                if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
                // else if(maxAction == 'share')
                //     (<any>this).$edMessage.success(this.$t('openTips'));
                return;
            }

            this.setLibs();

            if (this.isPlugin) {
                location.href = `${window.location.origin}${appConfig["sourcePath"]}app.html?plugin=board`;
                return;
            }

            if (!this.userInfo) {
                ts.$bus.$emit("login");
                return;
            }
            if (this.activeMenuID == -1 && this.activeLv2ID != -1) {
                // 使用时增加分类最近记录
                let id = this.activeLv3ID;
                if (id == -1) {
                    id = this.lv3List[0].id;
                }
                this.addSubclass2Recent(id);
                let lv3Item = this.findLv3Item(id);
                if (typeof lv3Item != "number") {
                    this.sensors.track("clickEmbedTemplate", {
                        Catalogues: "Templates",
                        diagram_type: lv3Item.lv3.name,
                        platform: this.isPC ? "desktop" : "online",
                    });
                    typeTrack = lv3Item.lv3.name;
                }
            }
            let newTab: any;
            if (!this.openInTabs) {
                newTab = window.open(`${window.location.origin}${appConfig["sourcePath"]}app.html`, "");
            }

            // newTab.location.href = `${window.location.origin}/app.html?action=openfile`;
            // return;

            let limitCallback = (type = "") => {
                newTab && newTab.close();
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        console.log("on event");
                        this.$bus.$off("limitModalContinue");
                        this.addNewPage();
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    this.$checkAuth({
                        type: "cloudSpaceVIP",
                        buyTrigger: "cloudSpacePop",
                        pcParams: { newUpgrade: 6, upgrade: 0 },
                    });
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({
                        type: "cloudSpace",
                        buyTrigger: "cloudSpacePop",
                        pcParams: { newUpgrade: 6, upgrade: 0 },
                    });
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: "fileNum",
                    });
                }
            };

            let enterCanvasTrack = `&file_source=emptyFile&template_type=noTemplate&diagram_type=${typeTrack}&fromNull=1`;
            let trackSuffix = this.isAd ? `&from=ad` : "";
            trackSuffix += enterCanvasTrack;
            trackSuffix += `&classID=${this.activeLv3ID}`;
            this.$openFile({
                params: {
                    newFileName: this.$t("newFile"),
                    libs: JSON.parse(localStorage.getItem("libs") || "[]"),
                },
                fileType: "emptyFile",
                suffix: trackSuffix,
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitCallback,
                vip: this.vip,
                from: this.from,
                isFullCouldSpace: this.isFullCouldSpace,
            })
                .then((obj) => {
                    this.$bus.$emit("refreshList"); // 在 /workbench 路由下自动更新文件列表（非此路由 $bus 方法无法执行，但是切换到工作台时会手动更新文件列表）
                    this.$gaTrack("openFileProcess_enterCanvas", `fileSource: emptyFile}`);
                    this.sensors.track("generateCloudFile", {
                        Catalogues: "openFileProcess",
                        file_source: "templateFile",
                    });
                    if (this.openInTabs) {
                        location.href = obj.url;
                    } else {
                        newTab.location.href = obj.url;
                    }
                    this.$store.commit("setAppState", "create");
                    let timer = setInterval(() => {
                        try {
                            newTab.name;
                            newTab.name = obj.obj;
                            if (!newTab.name) {
                                this.$store.commit("setAppState", "");
                                clearInterval(timer);
                            }
                            if (!newTab.location.hash) {
                                this.$store.commit("setAppState", "");
                                clearInterval(timer);
                            }
                        } finally {
                        }
                    }, 1000);
                    this.openNullFlag = false;

                    // add open record
                    let key = obj.obj;
                    let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                    if (!openTabs.includes(key)) {
                        openTabs.push(key);
                    }
                    this.$store.commit("addWin", newTab);
                    localStorage.setItem("openTabs", JSON.stringify(openTabs));
                })
                .catch((err) => {
                    this.openNullFlag = false;
                });
        }
        addSubclass2Recent(id) {
            if (this.isPlugin) return;
            if (!this.$validateLogin()) return;
            this.$edApi
                .addTemplateHistory({
                    user_id: this.userInfo.id,
                    token: this.userInfo.token,
                    data: {
                        sub_class_id: id,
                    },
                })
                .then((e) => {
                    this.initRecentData(1);
                });
        }
        initRecentData(flag = 0) {
            if (!this.$validateLogin()) return;
            let user = {
                user_id: this.userInfo.id,
                token: this.userInfo.token,
            };
            let getSubClass = () => {
                return new Promise((rs, rj) => {
                    this.$edApi.getSubClassHistory(user).then((e) => {
                        this.recentSubclass = e;
                        rs("");
                    });
                });
            };
            let getTemplate = () => {
                return new Promise((rs, rj) => {
                    this.$edApi.getTemplateHistory(user).then((e) => {
                        this.recentTemplate = e;
                        rs("");
                    });
                });
            };
            switch (flag) {
                case 0:
                    let arr = [];
                    arr.push(getSubClass());
                    arr.push(getTemplate());
                    Promise.all(arr).then((e) => {
                        this.recentLoaded = true;
                    });
                    break;
                case 1:
                    getSubClass();
                    break;
                case 2:
                    getTemplate();
                    break;
            }
        }
        findLv3Item(lv3ID): number | { lv1: any; lv2: any; lv3: any } {
            for (let i = 0; i < this.allTemplate.length; i++) {
                let lv2 = this.allTemplate[i].lv2;
                for (let j = 0; j < lv2.length; j++) {
                    let lv3 = lv2[j].lv3;
                    for (let k = 0; k < lv3.length; k++) {
                        if (lv3[k].id == lv3ID) {
                            let obj = {
                                lv1: this.allTemplate[i],
                                lv2: lv2[j],
                                lv3: lv3[k],
                            };
                            return obj;
                        }
                    }
                }
            }
            return -1;
        }
        setLibs() {
            // 根据当前选中类型设置初始符号库列表
            let libs = [];
            if (this.activeLv3ID != -1) {
                let index = -1;
                for (let i = 0; i < this.typeItemList.length; i++) {
                    if (this.typeItemList[i].id == this.activeLv3ID) {
                        index = i;
                        break;
                    }
                }
                if (index != -1) {
                    libs = this.typeItemList[index].libs || [];
                    localStorage.setItem("libs", JSON.stringify(libs));
                }
            } else {
                let store = localStorage;
                let rememberStatus = store.getItem("rememberLib");
                if (parseInt(rememberStatus)) {
                    let libs = store.getItem("rememberLibList");
                    localStorage.setItem("libs", libs);
                } else {
                    localStorage.setItem("libs", "[373, 14, 4]");
                }
            }
        }

        created() {
            console.log(123123);
            // 使用该组件下的 openNull() 方法作为 public 目录下的公共新建文件事件
            this.$bus.$on("publicNewFile", () => {
                console.log("publicNewFile");
                this.openNull();
            });
        }

        mounted() {}

        beforeDestroy() {
            this.$bus.$off("publicNewFile");
        }
    }
</script>

<i18n>
{
    "zh": {
        "emptyDrawing": "空白绘图",
        "productRec": "产品推荐",
        "newFile": "未命名文件",
        "create": "正在创建文件中，请稍后再试"
    },
    "en": {
        "emptyDrawing": "Blank drawing",
        "productRec": "Recommended",
        "newFile": "Unnamed File",
        "create": "Creating file, please try again later."
    },
    "fr": {
        "emptyDrawing": "Dessin vierge",
        "productRec": "Conseillé",
        "newFile": "Fichier sans nom",
        "create": "Creating file, please try again later."
    },
    "de": {
        "emptyDrawing": "Leere Zeichnung",
        "productRec": "Empfohlen",
        "newFile": "Unbenannte Datei",
        "create": " Datei wird erstellt, versuchen Sie es später erneut"
    },
    "jp": {
        "emptyDrawing": "空白の図面",
        "productRec": "おすすめ商品",
        "newFile": "名前のないファイル",
        "create": "ファイルを作成しています。しばらくしてからもう一度お試しください"
    },
    "es": {
        "emptyDrawing": "Dibujo en blanco",
        "productRec": "Recomendado",
        "newFile": "Archivo sin nombre",
        "create": "Creando archivo, por favor intente nuevamente más tarde."
    },
    "it": {
        "emptyDrawing": "Disegno vuoto",
        "productRec": "Consigliato",
        "newFile": "File Senza Nome",
        "create": "Creazione file in corso. Si prega di riprovare."
    },
    "pt": {
        "emptyDrawing": "Desenho em branco",
        "productRec": "Recomendado",
        "newFile": "Ficheiro Sem Nome",
        "create": "Criando ficheiro, por favor, tentar mais tarde."
    },
    "tw": {
        "emptyDrawing": "空白繪圖",
        "productRec": "產品推薦",
        "newFile": "未命名檔案",
        "create": "正在建立檔案中，請稍後再試"
    },
    "kr": {
        "emptyDrawing": "빈 그림",
        "productRec": "추천 제품",
        "newFile": "이름이없는 파일",
        "create": "파일을 만드는 중입니다. 나중에 다시 시도하세요~"
    }
}
</i18n>
